import { render } from "./Marquee.vue?vue&type=template&id=1e52232e&scoped=true&lang=pug"
import script from "./Marquee.vue?vue&type=script&lang=js"
export * from "./Marquee.vue?vue&type=script&lang=js"

import "./Marquee.vue?vue&type=style&index=0&id=1e52232e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1e52232e"

export default script